import {
    GET_PRODUCT_BY_ID,
    GET_PRODUCT_BY_ID_ERROR,
    GET_PRODUCT_BY_ID_SUCCESS,
} from "core-web/state/models/Page/constants";

import Events from "core-web/libs/Events";
import { NOT_ACTIVE_ONLINE } from "theme/config/constants";
import { ProductEvents } from "core-web/libs/Events/constants";
import { getFlag } from "core-web/utils/getFlag";
import { getProductAutomatedDiscounts } from "./getProductAutomatedDiscounts";
import { inServer } from "core-web/constants";
import { isEmpty } from "core-web/utils/object";
import store from "core-web/state/store";

export const handleProductData =
    (partNo, responseProductData, location, applicationId, url, ssrCookies) => async (dispatch, getState) => {
        if (partNo) {
            dispatch({ type: GET_PRODUCT_BY_ID });
            try {
                const productData = JSON.parse(JSON.stringify(responseProductData || {}));
                if (isEmpty(productData)) {
                    throw new Error("Product data is empty");
                }

                const productVariants = productData.variants || [];
                const isMultipleVariants = productData.variants.length > 1;
                productData.variants = productVariants.filter((variant) => {
                    if (getFlag(NOT_ACTIVE_ONLINE, variant?.format?.flags)) {
                        return false;
                    }

                    if (!isMultipleVariants) {
                        return true;
                    }

                    const variantParametrics = variant?.variant_parametrics || [];
                    if (!variantParametrics.length) {
                        return false;
                    }

                    return variantParametrics.every((parametric) => parametric.value);
                });

                if (!inServer) {
                    Events.trigger(ProductEvents.VIEW, {
                        data: productData,
                    });
                }

                dispatch({
                    type: GET_PRODUCT_BY_ID_SUCCESS,
                    product: productData,
                });

                await getProductAutomatedDiscounts(
                    productData,
                    location,
                    url,
                    applicationId,
                    ssrCookies,
                )(dispatch, getState);
            } catch (e) {
                // @todo: handle page when product couldn't fetch
                console.error(`ProductPage error: Could not fetch product with partNo ${partNo} from the API.`);
                dispatch({ type: GET_PRODUCT_BY_ID_ERROR });
            }
        }
    };

export default (partNo, responseProductData, location, applicationId, url, ssrCookies = {}) =>
    store.dispatch(handleProductData(partNo, responseProductData, location, applicationId, url, ssrCookies));
